const toggle = document.querySelector(".nav-toggle");
const navMenu = document.querySelector(".nav-menu");

toggle.addEventListener("click", () => {
  //set the top position of the menu to be the height of the main nav, so it appears just below it when opened.
  const mainNavHeight = document
    .querySelector(".main-nav")
    .getBoundingClientRect().height;
  navMenu.style.top = `${mainNavHeight}px`;

  //toggle open state and aria attribute for accessibility
  const open = toggle.getAttribute("aria-expanded") === "true";
  toggle.setAttribute("aria-expanded", String(!open));
  navMenu.classList.toggle("is-open", !open);
});
